import React from 'react';
import { Box, IconButton, TextField, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { CountryAutocomplete } from '../../inputs';
import { Destination } from '../../../models/tenant';
import { CountryCode } from '../../../models/country';


export interface DestinationRowProps {
  destination: Destination;
  onCountryChange: (code: CountryCode) => void;
  onCodesChange: (codes: string[]) => void;
  onScoreChange: (score: number | undefined) => void;
  onRemove: () => void;
}

const DestinationRow: React.FC<DestinationRowProps> = ({
  destination,
  onCountryChange,
  onCodesChange,
  onScoreChange,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
      <Box sx={{ minWidth: 250 }}>
        <CountryAutocomplete
          value={destination.country} 
          onChange={onCountryChange} 
          fullWidth={false}
          size="small"
        />
      </Box>
      <TextField
        label={t('Postal Codes')}
        placeholder={t('46, 29, 33 etc.')}
        value={destination.codes?.join(',') ?? ''}
        onChange={(e) => onCodesChange(e.target.value.split(','))}
        onBlur={(e) => onCodesChange(e.target.value.split(',').map(c => c.trim()).filter(c => c.length > 0))}
        sx={{ flex: 1 }}
        size="small"
      />
      <TextField
        label={t('Score')}
        type="number"
        value={destination.score ?? ''}
        onChange={(e) => onScoreChange(e.target.value ? Number(e.target.value) : undefined)}
        sx={{ minWidth: 100 }}
        size="small"
      />
      <Tooltip title={t('Remove destination')}>
        <IconButton onClick={onRemove} color="error" size="small" disableRipple>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default DestinationRow;
